// @flow

import React from 'react';
import i18n from 'app/common/lib/i18n';
import PrettyNumber from 'app/common/react/i18n/PrettyNumber';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';
import { Text } from 'gestalt';

type Props = {
  count: number,
  showAllDigits?: boolean,
};

export default function FollowerCount({ count, showAllDigits = true }: Props) {
  return (
    <Text color="gray" size="sm">
      {interpolateNamedTemplate(
        i18n.ngettext(
          '{{ followerCount }} Follower',
          '{{ followerCount }} Followers',
          count,
          'Label for the number of people following a user',
        ),
        {
          followerCount: (
            <strong key="follower_count">
              <PrettyNumber
                value={count}
                shortform={!showAllDigits}
                shortformMaximumFractionDigits={!showAllDigits ? 1 : undefined}
              />
            </strong>
          ),
        },
      )}
    </Text>
  );
}
